import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiDocumentFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 54 53",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10958_15073)",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 27,
			cy: 26.5,
			r: 26.5,
			fill: "url(#paint0_linear_10958_15073)"
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_10958_15073)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter0_dd_10958_15073)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M38.4675 43.6959H18.6675C17.0044 43.6959 15.6562 42.3477 15.6562 40.6847V14.2847C15.6562 12.6216 17.0044 11.2734 18.6675 11.2734H31.7479L41.4787 21.0043V40.6847C41.4787 42.3477 40.1305 43.6959 38.4675 43.6959Z",
						fill: "url(#paint1_linear_10958_15073)"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M38.4675 43.6959H18.6675C17.0044 43.6959 15.6562 42.3477 15.6562 40.6847V14.2847C15.6562 12.6216 17.0044 11.2734 18.6675 11.2734H31.7479L41.4787 21.0043V40.6847C41.4787 42.3477 40.1305 43.6959 38.4675 43.6959Z",
						stroke: "#98A2B3",
						strokeWidth: .5
					})]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.1278 26.5399C29.0411 26.3147 28.8247 26.166 28.5833 26.166C28.342 26.166 28.1255 26.3147 28.0389 26.5399L27.0273 29.1701C26.852 29.6257 26.797 29.757 26.7217 29.8629C26.6461 29.9692 26.5532 30.0621 26.4469 30.1377C26.341 30.213 26.2097 30.2681 25.7541 30.4433L23.1239 31.4549C22.8987 31.5415 22.75 31.758 22.75 31.9993C22.75 32.2407 22.8987 32.4572 23.1239 32.5438L25.7541 33.5554C26.2097 33.7306 26.341 33.7857 26.4469 33.861C26.5532 33.9366 26.6461 34.0295 26.7217 34.1358C26.797 34.2417 26.852 34.373 27.0273 34.8286L28.0389 37.4588C28.1255 37.684 28.342 37.8327 28.5833 37.8327C28.8247 37.8327 29.0411 37.684 29.1278 37.4588L30.1394 34.8286C30.3146 34.373 30.3697 34.2417 30.445 34.1358C30.5206 34.0295 30.6135 33.9366 30.7197 33.861C30.8257 33.7857 30.957 33.7306 31.4126 33.5554L34.0427 32.5438C34.268 32.4572 34.4167 32.2407 34.4167 31.9993C34.4167 31.758 34.268 31.5415 34.0427 31.4549L31.4126 30.4433C30.957 30.2681 30.8257 30.213 30.7197 30.1377C30.6134 30.0621 30.5206 29.9692 30.445 29.8629C30.3697 29.757 30.3146 29.6257 30.1394 29.1701L29.1278 26.5399Z",
					fill: "url(#paint2_linear_10958_15073)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.3969 34.4237C24.3761 34.3697 24.3241 34.334 24.2662 34.334C24.2083 34.334 24.1563 34.3697 24.1355 34.4237L23.8928 35.055C23.8507 35.1643 23.8375 35.1958 23.8194 35.2212C23.8013 35.2468 23.779 35.269 23.7535 35.2872C23.7281 35.3053 23.6965 35.3185 23.5872 35.3605L22.956 35.6033C22.9019 35.6241 22.8662 35.6761 22.8662 35.734C22.8662 35.7919 22.9019 35.8439 22.956 35.8647L23.5872 36.1074C23.6965 36.1495 23.7281 36.1627 23.7535 36.1808C23.779 36.1989 23.8013 36.2212 23.8194 36.2467C23.8375 36.2721 23.8507 36.3037 23.8928 36.413L24.1355 37.0442C24.1563 37.0983 24.2083 37.134 24.2662 37.134C24.3241 37.134 24.3761 37.0983 24.3969 37.0442L24.6397 36.413C24.6817 36.3037 24.6949 36.2721 24.713 36.2467C24.7312 36.2212 24.7534 36.1989 24.7789 36.1808C24.8044 36.1627 24.8359 36.1495 24.9452 36.1074L25.5765 35.8647C25.6305 35.8439 25.6662 35.7919 25.6662 35.734C25.6662 35.6761 25.6305 35.6241 25.5765 35.6033L24.9452 35.3605C24.8359 35.3185 24.8044 35.3053 24.7789 35.2872C24.7534 35.269 24.7312 35.2468 24.713 35.2212C24.6949 35.1958 24.6817 35.1643 24.6397 35.055L24.3969 34.4237Z",
					fill: "url(#paint3_linear_10958_15073)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.7973 26.9569C32.7765 26.9029 32.7245 26.8672 32.6666 26.8672C32.6087 26.8672 32.5567 26.9029 32.5359 26.9569L32.2931 27.5882C32.2511 27.6975 32.2379 27.729 32.2198 27.7545C32.2017 27.78 32.1794 27.8022 32.1539 27.8204C32.1284 27.8385 32.0969 27.8517 31.9876 27.8937L31.3563 28.1365C31.3023 28.1573 31.2666 28.2093 31.2666 28.2672C31.2666 28.3251 31.3023 28.3771 31.3563 28.3979L31.9876 28.6406C32.0969 28.6827 32.1284 28.6959 32.1539 28.714C32.1794 28.7321 32.2017 28.7544 32.2198 28.7799C32.2379 28.8053 32.2511 28.8369 32.2931 28.9462L32.5359 29.5774C32.5567 29.6315 32.6087 29.6672 32.6666 29.6672C32.7245 29.6672 32.7765 29.6315 32.7973 29.5774L33.0401 28.9462C33.0821 28.8369 33.0953 28.8053 33.1134 28.7799C33.1315 28.7544 33.1538 28.7321 33.1793 28.714C33.2048 28.6959 33.2363 28.6827 33.3456 28.6406L33.9769 28.3979C34.0309 28.3771 34.0666 28.3251 34.0666 28.2672C34.0666 28.2093 34.0309 28.1573 33.9769 28.1365L33.3456 27.8937C33.2363 27.8517 33.2048 27.8385 33.1793 27.8204C33.1538 27.8022 33.1315 27.78 33.1134 27.7545C33.0953 27.729 33.0821 27.6975 33.0401 27.5882L32.7973 26.9569Z",
					fill: "url(#paint4_linear_10958_15073)"
				}),
				/* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter1_d_10958_15073)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M32.1562 11.6836L41.0704 20.5977H35.1675C33.5045 20.5977 32.1562 19.2495 32.1562 17.5865V11.6836Z",
						fill: "white"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M32.1562 11.6836L41.0704 20.5977H35.1675C33.5045 20.5977 32.1562 19.2495 32.1562 17.5865V11.6836Z",
						stroke: "#98A2B3",
						strokeWidth: .5
					})]
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd_10958_15073",
			x: 9.40625,
			y: 9.02344,
			width: 38.3223,
			height: 44.9219,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 2,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect1_dropShadow_10958_15073"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10958_15073"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 2,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect2_dropShadow_10958_15073"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_10958_15073",
					result: "effect2_dropShadow_10958_15073"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_10958_15073",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_10958_15073",
			x: 28.9062,
			y: 9.08008,
			width: 15.7676,
			height: 15.7676,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_10958_15073"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_10958_15073",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10958_15073",
			x1: 27,
			y1: 0,
			x2: 27,
			y2: 53,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F5F5F6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F5F5F6",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_10958_15073",
			x1: 23.5684,
			y1: 11.9844,
			x2: 23.5684,
			y2: 42.9844,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .147835,
				stopColor: "white"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FDFEFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_10958_15073",
			x1: 22.7498,
			y1: 37.8326,
			x2: 34.4165,
			y2: 26.1659,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#AD00FE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00E0EE"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_10958_15073",
			x1: 22.8662,
			y1: 37.134,
			x2: 25.6662,
			y2: 34.334,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#AD00FE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00E0EE"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_10958_15073",
			x1: 31.2666,
			y1: 29.6672,
			x2: 34.0666,
			y2: 26.8672,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#AD00FE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00E0EE"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10958_15073",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 53,
				height: 53,
				fill: "white",
				transform: "translate(0.5)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_10958_15073",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 51,
				height: 46,
				fill: "white",
				transform: "translate(3 11)"
			})
		})
	] })]
});
export default SvgAiDocumentFilled;
